/* eslint-disable max-len */
import { ICONS_ID } from '@bitComponents/unifiedIcons/SvgIconLoader';
import { CQ_ACTION_CODES } from '../../../catalogConstants';
import { STRING_KEYS } from '../../common';
import { USER_TYPE } from '../../../bitConstants/constants';

export const localizedStrings = {
  common: {
    everyMainSelection: {
      [STRING_KEYS.summary.title]: 'Hola {name}, completa tu pedido',
      [STRING_KEYS.summary.cart.manualOneTimeChargesTitle]: 'Cuota de alta',
      [STRING_KEYS.summary.cart.manualOneTimeChargesFinalPriceText]: 'Pago único',
      [STRING_KEYS.summary.cart.manualRecurringChargesTitle]: '',
      [STRING_KEYS.summary.cart.manualRecurringChargesFinalPriceText]: 'Cuota mensual',
      [STRING_KEYS.summary.packMobileLineAction.title]: 'Configuración líneas móviles incluidas',
      [STRING_KEYS.summary.landLineAction.title]: 'Línea fija',
      [STRING_KEYS.summary.storeShipping.title]: 'Recogida en tienda nuevas SIMs',
      [STRING_KEYS.provisionalAgreement.title]: '',
      [STRING_KEYS.provisionalAgreement.pdfLinkText]: 'Descarga del resumen del contrato (PDF).',
      [STRING_KEYS.payment.step.insertDirectDebit]: '',
      [STRING_KEYS.summary.staticDirectDebit]: 'En tu factura Movistar',
      [STRING_KEYS.mainAction[CQ_ACTION_CODES.MIGRATION].multiplePhoneNumbers]: 'Quiero pasar un número Movistar a esta tarifa',
      [STRING_KEYS.mobileSecondaryAction[CQ_ACTION_CODES.MIGRATION].multiplePhoneNumbers]: 'Quiero pasar un número Movistar a esta tarifa',
    },
    [`mainSelection_${CQ_ACTION_CODES.REGISTER}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.PORTABILITY}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.MIGRATION}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.ACTIVATE_LINE}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.UPGRADE_INCLUDED_LINE}`]: {
    },
  },
  [`user_${USER_TYPE.TELCO}`]: {
    everyMainSelection: {
      [STRING_KEYS.summary.storeShipping.text]: 'Si has solicitado portabilidad o nuevas líneas móviles podrás recoger tus SIMs en cualquier tienda Movistar.',
      [STRING_KEYS.summary.storeShipping.secondaryText]: 'En caso de portabilidad te confirmaremos con un SMS cuándo puedes ir a por ella/s.',
    },
    [`mainSelection_${CQ_ACTION_CODES.REGISTER}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.PORTABILITY}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.MIGRATION}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.ACTIVATE_LINE}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.UPGRADE_INCLUDED_LINE}`]: {
    },
  },
  [`user_${USER_TYPE.OPEN}`]: {
    everyMainSelection: {
      [STRING_KEYS.summary.title]: '',
      [STRING_KEYS.summary.storeShipping.text]: 'Podrás recoger tus SIMs en cualquier tienda Movistar.',
      [STRING_KEYS.summary.storeShipping.secondaryText]: 'En caso de portabilidad te confirmaremos con un SMS cuándo puedes ir a por ella/s.',
    },
    [`mainSelection_${CQ_ACTION_CODES.REGISTER}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.PORTABILITY}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.MIGRATION}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.ACTIVATE_LINE}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.UPGRADE_INCLUDED_LINE}`]: {
    },
  },
}
